'use strict';

const IsotopicDistribution = require('./IsotopicDistribution');

module.exports = IsotopicDistribution;



// WEBPACK FOOTER //
// ./packages/isotopic-distribution/src/index.js